import dynamic from 'next/dynamic'
import { DemographicsIcon } from 'src/components/insights/icons/demographics'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/value-of-owner-occupied-housing-units.png'

const DemographicsValueOwnerOccupiedHousingUnits = dynamic(
  () => import('src/components/insights/demographics/cards/owner-housing-units'),
  {
    ssr: false,
  }
)

export const DemographicsValueOwnerOccupiedHousingUnitsWidget: InsightBuilderWidget = {
  id: 'value-of-owner-occupied-housing-units',
  name: 'Value of Owner Occupied Housing Units',
  type: 'Demographics',
  icon: DemographicsIcon,
  component: DemographicsValueOwnerOccupiedHousingUnits,
  supportedResultTypes: ['alphamap-location'],
  preview,
}
